var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<filter id=\"dropshadow\" height=\"200%\" width=\"200%\" x=\"-50%\" y=\"-50%\">\n    <feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\"/>\n    <feOffset dx=\"2\" dy=\"2\" result=\"offsetblur\"/>\n    <feMerge>\n        <feMergeNode/>\n        <feMergeNode in=\"SourceGraphic\"/>\n    </feMerge>\n</filter>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./common/ui/template/svg/dropshadow.hbs
// module id = 1168
// module chunks = 0